// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import VueVideoPlayer from 'vue-video-player'
import scroll from 'vue-seamless-scroll'

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
require('./assets/css/index.css')

Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(VueI18n)
Vue.use(VueVideoPlayer)
Vue.use(scroll)

Vue.http.options.root = 'http://39.96.51.69:8090/'

var store = new Vuex.Store({
  state: {
    langnum: ''
  },
  mutations: {
    changelangnum (state, num) {
      state.langnum = num
    }
  },
  getters: {}
})

const i18n = new VueI18n({
  locale: 'zh', // 语言标识
  messages: {
    'zh': require('./assets/lang/zh'),
    'en': require('./assets/lang/en'),
    'ew': require('./assets/lang/ew')
  }
})
Vue.config.productionTip = false
Vue.http.options.emulateJSON = true
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js